module.exports = __webpack_public_path__ + "static/media-dafa0edf1a753ddd921bdc450624c792.jpg";